import { daysOfWeeks, NZTimeZone } from "../../helper/constant";
import { AddEditJobInterface } from "../../helper/interface";
import { default as momentTimeZone } from "moment-timezone";

const getFormDate = (date: Date | string | null) => momentTimeZone(date).format("YYYY-MM-DD");

const createDateTime = (date: string, time: string, timeZone: string) => {
    return momentTimeZone.tz(`${date} ${time}`, "YYYY-MM-DD HH:mm", timeZone).toISOString();
};

export const JobPayloadFn = (values: AddEditJobInterface) => {
    const payload: AddEditJobInterface = { ...values };
    const timeZone = values.centreForJob?.timeZone ?? NZTimeZone;
    const startDate = getFormDate(values.startDate);
    let endDate = values.endDate ? getFormDate(values.endDate) : startDate;

    if (values.repeat === "Same week" && values.daysOfWeek?.length) {
        const selectedDays = values.daysOfWeek.map((day) => daysOfWeeks.indexOf(day.value));
        const lastSelectedDay = Math.max(...selectedDays);
        const startDay = momentTimeZone.tz(startDate, timeZone).isoWeekday() - 1;
        const dayOffset = (lastSelectedDay - startDay + daysOfWeeks.length) % daysOfWeeks.length;

        endDate = momentTimeZone.tz(startDate, timeZone).add(dayOffset, "days").format("YYYY-MM-DD");
    }

    payload.startDate = createDateTime(startDate, values.startTime, timeZone);
    payload.endDate = createDateTime(endDate, values.endTime, timeZone);

    return payload;
};
